import { useMutation } from '@tanstack/react-query';
import { IHandleSendDataParams } from './Types';
import { configApi } from '../configApi';

const handleRequestData = async <T>(data: T, params: IHandleSendDataParams) => {
  const urlRequest = params.idForUpdate ? `${params.endPoint}/update/${params.idForUpdate}` : params.endPoint;
  const typeRequest = params.idForUpdate ? configApi.patch : configApi.post;

  const response = await typeRequest(`/${urlRequest}/`, data);

  return response.data;
};

export const useHandleSendData = <T>(params: IHandleSendDataParams) => {
  return useMutation({
    mutationFn: (data: T) => handleRequestData<T>(data, params),
    mutationKey: [params.keyRequest],
  });
};
